import { BroadcastEventEnum, RecordEventEnum } from "@/types/recording";

export const channel = new BroadcastChannel("recordingStatus");

export function sendRequestStatus() {
  channel.postMessage({ event: BroadcastEventEnum.RECORDING, type: RecordEventEnum.REQUEST_STATUS });
}

export function sendRecordingStatus(status: RecordEventEnum) {
  channel.postMessage({ event: BroadcastEventEnum.RECORDING, type: status });
}
